import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Menu from '@material-ui/core/Menu';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { showSnack } from '../../actions/uiActions';
import { getMessage } from '../../reducers/i18n';
import { getCurrentBaseUri } from '../../reducers/page';
import { getActiveSewpatId } from '../../reducers/sewpats';

import SVGIcon from '../Icon';
import FlatInput from '../styles/FlatInputShareMenu';
import IconText from '../styles/IconText';
import Pin from './PinterestIcon';
import MenuItem from './ShareMenuItem';

defineMessages({
    shareOnPinterest: {
        id: 'SHARE_ON_PINTEREST_BUTTON_LABEL',
        defaultMessage: 'Pin it',
    },
    shareOnPinterestPrefix: {
        id: 'SHARE_ON_PINTEREST_DEFAULT_PREFIX',
        description: 'Text we put in front of pattern title and description.',
        defaultMessage: 'Meine Farben. Mein Stoff. Mein Designerstück. Selbst designt bei www.schnoffle.de #designerstück #diy #diyfashion #fashion #schnittmuster #madeingermany #fashiondesign #nähen #nähenfürmich #geschenkidee #stofflove #stoffliebe',
    },
    shareOnPinterestSuffix: {
        id: 'SHARE_ON_PINTEREST_DEFAULT_SUFFIX',
        description: 'Text we put after the pattern title and description.',
        defaultMessage: 'Meine Farben. Mein Stoff. Mein Designerstück. Selbst designt bei www.schnoffle.de #designerstück #diy #diyfashion #fashion #schnittmuster #madeingermany #fashiondesign #nähen #nähenfürmich #geschenkidee #stofflove #stoffliebe',
    },
    shareOnInstagram: {
        id: 'SHARE_ON_INSTAGRAM_BUTTON_LABEL',
        defaultMessage: 'Instagram',
    },
    shareOnFacebook: {
        id: 'SHARE_ON_FACEBOOK_BUTTON_LABEL',
        defaultMessage: 'Facebook',
    },
    sharePerLink: {
        id: 'SHARE_COPY_LINK_BUTTON_LABEL',
        defaultMessage: 'Link kopieren',
    },
    shareOnWhatsapp: {
        id: 'SHARE_ON_WHATSAPP_BUTTON_LABEL',
        defaultMessage: 'Whatsapp',
    },
    snackCopied: {
        id: 'SNACK_LINK_COPIED_TO_CLIPBOARD',
        defaultMessage: 'Der Link zum Motiv wurde in die Zwischenablage kopiert.',
    },
});


class ShareMenu extends React.Component {

    state = {
        anchorEl: null,
        open: false,
    };

    handleClick = event => {
        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    pinProps = {
        name: 'icon-pinterest2',
        width: '1.3em',
        height: '1.3em',
        iconColor: 'blueGrey.700',
    };

    linkProps = {
        name: 'icon-link',
        width: '1.4em',
        height: '1.2em',
        iconColor: 'blueGrey.700',
    };

    iconProps = {
        name: 'icon-share',
        width: '1.5rem',
        height: '1.5rem',
        iconColor: 'blueGrey.700',
    };

    onCopyClick = () => {
        if (this.input && this.input.select) {
            // select text
            this.input.select();
            try {
                // copy text
                document.execCommand('copy');
                this.input.blur();
            }
            catch (err) {
                alert('please press Ctrl/Cmd+C to copy');
            }
        }
        this.props.showSavedToClipBoard(Date.now());
        this.handleRequestClose();
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
            anchorEl: null,
        });
    };

    getUri = () => {
        let uri = this.props.shareBaseUri;
        uri = `${uri}/schnoff/${this.props.sewpatId}/${this.props.pattern.id}`;
        if (this.props.query) {
            const query = queryString.stringify(this.props.query);
            if (query.length > 0) {
                uri = `${uri}?${query}`;
            }
        }
        return uri;
    };

    getMedia = () => this.props.imgSrc || (
        (
            (
                this.props.pattern || {}
            ).thumbnails || {}
        ).xlargeDiscreet || {}
    ).url;

    getDescription = () => {
        const pattern = this.props.pattern;
        const description = `${this.props.pattern.title} - Designerstück (Schnittmuster Berlin) auf umfärbbaren Stoffmotiv designt von ${this.props.designerName} | www.schnoffle.de`;
        return description;
    };

    render() {
        const { shareMenuLabel } = this.props;
        return (
            <React.Fragment>
                <BottomNavigationAction
                    onClick={this.state.open ? null : this.handleClick}
                    component='div'
                    label={<IconText>{shareMenuLabel}</IconText>}
                    value='share'
                    icon={<SVGIcon
                        {...this.iconProps}
                    />}
                    id={this.props.patternid}
                    key={this.props.patternid}
                    show
                />

                <Menu
                    id='simple-menu'
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={this.handleRequestClose}
                >
                    <MenuItem handleClick={this.handleRequestClose}>
                        <Pin
                            iconProps={this.pinProps}
                            buttonText={this.props.sharePinterestLabel}
                            shareTarget={this.getUri()}
                            media={this.getMedia()}
                            description={this.getDescription()}
                        />
                    </MenuItem>
                    <MenuItem
                        ref={element => {
                            this.button = element;
                        }} handleClick={this.onCopyClick}
                    >
                        <FlatInput>
                            <SVGIcon {...this.linkProps} /> {this.props.shareLinkLabel}
                            <input
                                ref={element => {
                                    this.input = element;
                                }}
                                type={'text'}
                                value={this.getUri()}
                                readOnly
                            />
                        </FlatInput>
                    </MenuItem>

                </Menu>
            </React.Fragment>
        );
    }

}


const mapDispatchToProps = dispatch => (
    {
        showSavedToClipBoard: id => dispatch(showSnack(
            id,
            'SNACK_LINK_COPIED_TO_CLIPBOARD',
            null,
            3000,
            null,
        )),
    }
);

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const sharePinterest = getMessage(
        initialState,
        'SHARE_ON_PINTEREST_BUTTON_LABEL',
    );
    const sharePinterestPrefix = getMessage(
        initialState,
        'SHARE_ON_PINTEREST_DEFAULT_PREFIX',
    );
    const shareLabel = getMessage(initialState, 'ICON_LABEL_SHARE');
    const shareLink = getMessage(initialState, initialOwnProps.messageId ||
        'SHARE_COPY_LINK_BUTTON_LABEL');
    const sewpatId = getActiveSewpatId(initialState);
    const mapStateToProps = state => (
        {
            sharePinterestLabel: sharePinterest,
            sharePinterestPrefix,
            shareLinkLabel: shareLink,
            shareBaseUri: getCurrentBaseUri(state),
            shareMenuLabel: shareLabel,
            sewpatId,
            ...initialOwnProps,
        }
    );
    return mapStateToProps;
};

ShareMenu.defaultProps = {
    pattern: {},
};

ShareMenu.propTypes = {
    pattern: PropTypes.object.required,
};

export default connect(makeMapStateToProps, mapDispatchToProps)(ShareMenu);



// WEBPACK FOOTER //
// ./src/components/sharing/ShareMenu.js